<div *ngIf="isOpen"
  class="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4 animate-fade-in">
  <div
    class="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-sm relative overflow-hidden animate-scale-up border border-slate-100/50">

    <!-- Close button -->
    <button (click)="onClose()"
      class="absolute top-4 right-4 w-8 h-8 rounded-full bg-white/80 hover:bg-slate-100 text-slate-400 hover:text-rose-500 transition-colors flex items-center justify-center shadow-sm z-10 border border-slate-100">
      <img src="icons/close_slate_dark.svg" />
    </button>

    <!-- Header Section -->
    <div class="bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] pt-10 pb-6 px-6 text-center relative shadow-sm text-white">
      <h3 class="text-xl font-black tracking-wide text-white">
        {{ currentLang === "TH" ? "จัดการข้อมูลบัตรจอดรถ" : "Manage Parking Card" }}
      </h3>
      <p class="text-[10px] text-amber-400 font-bold mt-1 uppercase tracking-wider">
        {{ currentLang === "TH" ? "ตรวจสอบและแก้ไขทะเบียนรถที่เชื่อมโยง" : "Check & update linked vehicle plates" }}
      </p>
    </div>

    <div class="p-6 space-y-4 text-sm" *ngIf="card">
      <!-- Card Logo container -->
      <div class="flex justify-center mb-1">
        <div
          class="w-20 h-20 bg-slate-50 rounded-2xl p-2.5 shadow-inner border border-slate-100 flex items-center justify-center">
          <img [src]="card.logoBase64" alt="card-logo" class="w-full h-full object-contain mix-blend-multiply" />
        </div>
      </div>

      <!-- Metadata table -->
      <div class="bg-slate-50 rounded-2xl p-4.5 space-y-3.5 border border-slate-100 text-xs">
        <div class="flex flex-col gap-1 text-left">
          <span class="text-slate-400 font-bold uppercase tracking-wider text-[9px]">{{ currentLang === "TH" ?
            "หมายเลขบัตรสมาชิก" : "Card Number" }}</span>
          <span class="font-black text-slate-800 text-sm font-mono leading-none">{{ card.cardName }}</span>
        </div>

        <div class="flex justify-between items-center border-t border-slate-100 pt-3 text-left">
          <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "สถานที่จอดรถ" : "Location" }}</span>
          <span class="font-black text-slate-800">{{ card.siteName }}</span>
        </div>

        <div class="flex justify-between items-center text-left">
          <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "ประเภทรถ" : "Vehicle Type" }}</span>
          <span class="font-black text-slate-800 inline-flex items-center gap-1" style="font-size: 12px;">
            <img *ngIf="card.vehicleTypeId === 1" src="icons/directions_car_slate_dark.svg" />
            <img *ngIf="card.vehicleTypeId === 2" src="icons/motorcycle_slate_dark.svg" />
            {{ card.vehicleType }}
          </span>
        </div>

        <div class="flex justify-between items-center text-left" *ngIf="card.myVehicles && card.myVehicles.length > 0">
          <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "ทะเบียนรถ" : "License Plate"
            }}</span>
          <div class="flex flex-col items-end gap-1">
            <span
              class="inline-flex items-center border border-slate-300 bg-white rounded px-2 py-0.5 min-w-[70px] justify-center relative overflow-hidden shadow-sm"
              *ngFor="let v of card.myVehicles">
              <span class="text-[9px] font-black text-slate-800 tracking-wide font-prompt text-center leading-none">
                {{ v.plateNumber }}
                <span class="text-[6px] text-slate-400 font-bold block leading-none text-center mt-0.5">
                  {{ v.province }}
                </span>
              </span>
            </span>
          </div>
        </div>

        <div class="flex justify-between items-center border-t border-slate-100 pt-3 text-left">
          <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "วันหมดอายุสมาชิก" : "Expire Date" }}</span>
          <span class="font-black text-rose-500">{{ card.expireDate | date : "dd/MM/yyyy" }}</span>
        </div>
      </div>

      <!-- Change Plate Button -->
      <button
        class="w-full py-3.5 rounded-2xl bg-amber-400 text-slate-800 text-xs font-black shadow-md hover:bg-amber-500 active:scale-95 transition-all flex justify-center items-center gap-1.5 outline-none border-none"
        (click)="onChangePlate()">
        <img src="icons/edit_square_slate_dark.svg" />
        {{ currentLang === "TH" ? "ขอแก้ไขเปลี่ยนทะเบียนรถ" : "Request Change Plate" }}
      </button>

    </div>
  </div>
</div>

<app-my-vehicle-select [isOpen]="isVehicleSelectOpen" [card]="card" (close)="closeVehicleSelect()"
  (confirmSelection)="onConfirmVehicleSelect($event)"></app-my-vehicle-select>